module.exports = __webpack_public_path__ + "static/GlitchlessSonyax4e-41678c5b8daf1174c3eb84c53f5e2a26.png";